import guest from "@/middleware/guest";

export default [
  {
      path: '/',
      name: 'home',
      meta: { middleware: [guest] },
      component: () => import(/* webpackChunkName: "DashboardLayout" */ '@/modules/layout/HomeLayout'),
  },
];
